/**
 * falcon-api refuses to add someone to a pool before their 15th birthday (BCJ-18489). It comes as
 * the error code of a failed request, or as `?error=` on the itsme redirect back to the app.
 */
export const EMPLOYEE_UNDER_AGE_ERROR_CODE = 'EMPLOYEE_UNDER_AGE';

/** Translation key of the message shown for {@link EMPLOYEE_UNDER_AGE_ERROR_CODE}. */
export const EMPLOYEE_UNDER_AGE_MESSAGE_KEY = 'API_ERRORS.EMPLOYEE_UNDER_AGE';
